module.exports = __webpack_public_path__ + "static/media/small-close.d66754f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/small-close.svg
// module id = 130
// module chunks = 0